import React from "react";

import SaveFlowSvg from "../../assets/images/icons/steps/Save Flow State f.svg";

export const SaveFlowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={SaveFlowSvg}
        alt={alt || "Save Flow"}
    />
);
